module.exports = __webpack_public_path__ + "img/40_38_050_250.6c2d6eeb.jpg";